/*** IMPORTS FROM imports-loader ***/
var define = false;

import emitter from '../../mixin/emitter'

export default {
  name: 'UiFormCheckbox',

  mixins: [emitter],

  inheritAttrs: false,

  inject: {
    uiFormItem: {
      default: '',
    },
  },

  model: {
    prop: 'modelValue',
    event: 'input',
  },

  // language=HTML (for PhpStorm)
  template: `
    <div :class="[
      'form-check',
      { 
        'form-check-inline': inline,
        'is-disabled': disabled,
        'is-checked': isChecked,
      }
    ]">
      <label class="form-check-label">
        <input
          v-bind="$attrs"
          class="form-check-input"
          type="checkbox"
          :disabled="disabled"
          :value="truthyValue"
          :checked="isChecked"
          @change="handleChangeDomEvent"
        />
        <slot></slot>
        <template v-if="!$slots.default">{{ label }}</template>
      </label>
    </div>
  `,

  props: {
    modelValue: {},
    value: {},
    trueValue: {},
    falseValue: {},

    disabled: Boolean,
    label: {},
    inline: {
      type: Boolean,
      default: false,
    },

    // Deprecated:
    trueLabel: [String, Number],
    falseLabel: [String, Number],
  },

  computed: {
    truthyValue() {
      // BC support:
      if (this.trueLabel !== undefined) {
        return this.trueLabel
      }
      // --
      if (this.trueValue !== undefined) {
        return this.trueValue
      }
      if (this.value !== undefined) {
        return this.value
      }
      return true
    },

    falseyValue() {
      // BC support:
      if (this.falseLabel !== undefined) {
        return this.falseLabel
      }
      // --
      if (this.falseValue !== undefined) {
        return this.falseValue
      }
      return false
    },

    isChecked() {
      if ({}.toString.call(this.modelValue) === '[object Boolean]') {
        return this.modelValue
      }
      if (Array.isArray(this.modelValue)) {
        return this.modelValue.indexOf(this.truthyValue) > -1
      }
      if (this.modelValue !== null && this.modelValue !== undefined) {
        return this.modelValue === this.truthyValue
      }
      return false
    },
  },

  methods: {
    addToAndGetModelValue() {
      if (Array.isArray(this.modelValue)) {
        if (this.modelValue.indexOf(this.truthyValue) === -1) {
          return this.modelValue.slice().concat(this.truthyValue)
        }
        return this.modelValue
      }
      return this.truthyValue
    },

    removeFromAndGetModelValue() {
      if (Array.isArray(this.modelValue)) {
        const idx = this.modelValue.indexOf(this.truthyValue)
        if (idx !== -1) {
          const tmp = this.modelValue.slice()
          tmp.splice(idx, 1)
          return tmp
        }
        return this.modelValue
      }
      return this.falseyValue
    },

    handleChangeDomEvent(ev) {
      const newValue = ev.target.checked ? this.addToAndGetModelValue() : this.removeFromAndGetModelValue()
      this.handleChange(newValue)
      this.$emit('change', newValue, ev)
    },

    handleChange(newValue) {
      this.$emit('input', newValue)
      this.dispatch('UiFormItem', 'ui.form.change', newValue)
    },

    handleBlur(ev) {
      this.$emit('blur', ev)
      this.dispatch('UiFormItem', 'ui.form.blur', [this.modelValue])
    },
  },

  created() {
    if (this.checked) {
      this.handleChange(this.addToAndGetModelValue())
    }
  },
}

